import comp from "./ReorderImages";
export default comp;
